module.exports = __webpack_public_path__ + "static/media/first-order.84978899.svg";